import { useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentStatus() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const status = params.get("status");
  const type = params.get("type");
  const isSuccess = status === "success";
  const isConsultancy = type === "consultancy";
  const isCourse = type === "course";

  useEffect(() => {
    if (status !== "success" && status !== "failed") navigate("/");
  }, [status, navigate]);

  if (status !== "success" && status !== "failed") return null;

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center px-4" data-testid="payment-status-page">
      <div className="w-full max-w-md bg-[#FAF6F0] rounded-3xl soft-shadow p-8 text-center">
        <img src="/logo.jpeg" alt="Binfinite Mind" className="h-12 mx-auto mix-blend-multiply" />
        {isSuccess ? (
          <>
            <CheckCircle2 className="mx-auto text-[#2D5A47] mt-6" size={52} />
            <h1 className="font-display text-2xl font-bold text-[#2D5A47] mt-4" data-testid="payment-status-heading">
              {isConsultancy ? "Booking Confirmed!" : isCourse ? "Course Unlocked!" : "Congratulations!"}
            </h1>
            <p className="text-sm text-[#5A6E63] mt-3 leading-relaxed" data-testid="payment-status-message">
              {isConsultancy
                ? "Within 48 hours our team will connect with you on your phone number."
                : isCourse
                ? "Your video course is unlocked. Sign in to your dashboard with the email and mobile number you used to watch all lessons anytime. A confirmation has been sent to your email."
                : "You have successfully registered for the workshop. Your receipt with the Zoom workshop link and WhatsApp group invite has been sent to your email."}
            </p>
            <div className="mt-6 flex flex-wrap justify-center gap-3">
              {!isConsultancy && (
                <Link to="/dashboard" data-testid="payment-status-dashboard-btn">
                  <Button className="rounded-full bg-[#2D5A47] hover:bg-[#224536] text-[#FDFBF7] px-6">
                    {isCourse ? "Watch My Course" : "Go to My Sessions"}
                  </Button>
                </Link>
              )}
              <Link to="/" data-testid="payment-status-home-btn">
                <Button variant="outline" className="rounded-full border-[#2D5A47]/30 text-[#2D5A47] px-6">
                  Back to Home
                </Button>
              </Link>
            </div>
          </>
        ) : (
          <>
            <XCircle className="mx-auto text-red-500 mt-6" size={52} />
            <h1 className="font-display text-2xl font-bold text-[#2D5A47] mt-4" data-testid="payment-status-heading">
              Payment could not be completed
            </h1>
            <p className="text-sm text-[#5A6E63] mt-3 leading-relaxed" data-testid="payment-status-message">
              No money was deducted for a failed payment. If any amount was debited, it is auto-refunded by
              Razorpay within 5-7 working days. Please try again.
            </p>
            <Link to="/" data-testid="payment-status-retry-btn">
              <Button className="mt-6 rounded-full bg-[#D98E32] hover:bg-[#c17a24] text-[#FDFBF7] px-8">
                Try Again
              </Button>
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
